import { render, staticRenderFns } from "./RemoveMembersDialog.vue?vue&type=template&id=cb17f652&scoped=true&"
import script from "./RemoveMembersDialog.vue?vue&type=script&lang=ts&"
export * from "./RemoveMembersDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveMembersDialog.vue?vue&type=style&index=0&id=cb17f652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb17f652",
  null
  
)

export default component.exports